const useEntrevistaStore = defineStore("entrevista", () => {
  // state
  const entrevista = ref({
    id: null,
    biografia_id: null,
    respondida: false,
    usuario_id: null,
    regalo_id: null,
    regalo: null,
    completado: 0,
    preguntas: [],
    nro_primera_pregunta_no_respondida: 0,
    despachador: "Tipo de Biografía",
  });

  const entrevistas = ref([]);

  // getters

  const draft = computed(() => clone(entrevista.value));

  // mutations

  const setEntrevista = (payload) => {
    entrevista.value = payload;
  };

  const update = (e) => {
    if (e === entrevista.value.id) {
      setEntrevista(e);
    }

    let i = entrevistas.value.findIndex((ent) => ent.id === e.id);

    if (i !== -1) {
      entrevistas.value[i] = e;
    }
  };

  const clear = () => {
    entrevista.value = {
      id: null,
      biografia_id: null,
      respondida: false,
      usuario_id: null,
      completado: 0,
      preguntas: [],
      nro_primera_pregunta_no_respondida: 0,
      regalo_id: null,
      regalo: null,
      despachador: "Tipo de Biografía",
    };
  };

  const setEntrevistas = (payload) => (entrevistas.value = payload);

  // actions
  const fetch = (entrevista_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/entrevistas/${entrevista_id}/fetch-data`)
        .then(({ data }) => {
          setEntrevista(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/entrevistas/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .post(`/api/entrevistas/${datos.id}`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/entrevistas`, datos)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (entrevista_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/entrevistas/${entrevista_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchEntrevistaPorConfiguracion = (configuracion_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/entrevistas/fetch-entrevista-por-configuracion/${configuracion_id}`
        )
        .then(({ data }) => {
          setEntrevista(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardarRespuesta = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/entrevistas/${datos.entrevista_id}/guardar-respuesta`, datos)
        .then(({ data }) => {
          entrevista.value.completado = data.result
            ? data.completado
            : entrevista.value.completado;
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const entrevistaRespondida = (entr_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/entrevistas/${entr_id}/respondida`)
        .then(({ data }) => {
          entrevista.value.respondida = data.respondida;
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const getEntrevistas = (bio_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/entrevistas/biografia/${bio_id}`)
        .then(({ data }) => {
          setEntrevistas(data);
          resolve(data);
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };

  const ordenarPreguntaNoRespondida = (preg_id, callback) => {
    let preg = entrevista.value.preguntas.find((preg) => preg.id === preg_id);
    let i = entrevista.value.preguntas.findIndex((preg) => preg.id === preg_id);
    entrevista.value.preguntas.splice(i, 1);
    preg.responder_despues = true;
    entrevista.value.preguntas.push(preg);
    callback(i);
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/entrevistas/${entrevista.value.id}/ordenar-pregunta-no-respondida`,
          { preg_id }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const cargarEntrevistaGlobal = (entr_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/entrevistas/${entr_id}/fetch-data`)
        .then(({ data }) => {
          setEntrevista(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const verificarEntrevista = ({ bio, contenido }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/entrevistas/verificar/terminacion-entrevista`, {
          bio,
          contenido,
        })
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  return {
    entrevista,
    entrevistas,
    draft,
    setEntrevista,
    setEntrevistas,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchEntrevistaPorConfiguracion,
    guardarRespuesta,
    entrevistaRespondida,
    getEntrevistas,
    update,
    ordenarPreguntaNoRespondida,
    cargarEntrevistaGlobal,
    verificarEntrevista,
  };
});

export default useEntrevistaStore;
